export function waitForElement(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

/**
 *
 * @param callback
 * @param selectorToObserve if set, observes the element instantly
 * @param observerOptions
 * @returns {IntersectionObserver}
 */
export function createIntersectionObserver(
  callback,
  selectorToObserve,
  observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: [],
  },
) {
  const intersectionObserver = new IntersectionObserver(callback, observerOptions);
  if (selectorToObserve) {
    intersectionObserver.observe(document.querySelector(selectorToObserve));
  }
  return intersectionObserver;
}

//TODO[1]: Leave this in case MKT wants the position to update faster
// callback = (entries) => requestAnimationFrame(() => {
//   for (const entry of entries) {
//     styles.wrapper.left = entry.target.getBoundingClientRect().left + 'px';
//   }
// });
/**
 *
 * @param callback
 * @param selectorToObserve
 * @param observerOptions
 * @returns {ResizeObserver}
 */
export function createResizeObserver(selectorToObserve, callback, observerOptions = {}) {
  const resizeObserver = new ResizeObserver(callback);
  const el = document.querySelector('.content');
  if (selectorToObserve) {
    resizeObserver.observe(el, observerOptions);
  }
  return resizeObserver;
}
